import { render, staticRenderFns } from "./StockPurchaseOrderListDiscrepancy.vue?vue&type=template&id=4dc83cfc&scoped=true&"
import script from "./StockPurchaseOrderListDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./StockPurchaseOrderListDiscrepancy.vue?vue&type=script&lang=js&"
import style0 from "./StockPurchaseOrderListDiscrepancy.vue?vue&type=style&index=0&id=4dc83cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc83cfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VAutocomplete,VCard,VDataTable,VOverlay,VProgressCircular,VSkeletonLoader})
